import FormControlBase from "../../forms/FormControl";
import {ProgressBar} from "react-bootstrap";
import classNames from "classnames";
import React from "react";

class MainProgressBar extends FormControlBase {
    render = () => {
        const {min, max, value, color} = this.props;
        return <ProgressBar className={classNames('progress-bar', color)} min={min} max={max} now={value}/>
    };

    static defaultProps = {
        min: 0,
        max: 100,
        color: 'medium'
    };
}
export default MainProgressBar
